import { useJobStats } from '@/hooks/useJobs';
import { JobStatus } from '@/types';

/**
 * T1 ambient activity pill (ENG-5155 Activity Hub).
 *
 * Reads pre-aggregated job counts from `useJobStats` (backend statistics —
 * never a page array length) on the hook's default 30s poll. Renders nothing
 * until the query succeeds AND at least one job is running ("hidden at zero"
 * — never "0 running"). Non-interactive in v1: a `role="status"` chip, no
 * button semantics, no onClick.
 *
 * T1 tier is calm by design: pulse dot + stroke accent on a layer surface.
 * Never red, never `chariot-status-*` tokens.
 */
export function ActivityPill() {
  const { jobStats, status } = useJobStats();
  const running = jobStats[JobStatus.Running];

  if (status !== 'success' || running === 0) {
    return null;
  }

  return (
    <div
      role="status"
      aria-label={`${running} jobs running`}
      className="border-chariot-stroke bg-chariot-layer1 flex items-center gap-2 rounded-full border px-3 py-1"
    >
      <span
        aria-hidden="true"
        className="bg-chariot-stroke-blue size-2 rounded-full motion-safe:animate-pulse"
      />
      <span className="text-chariot-text-secondary text-xs font-medium">
        {running} running
      </span>
    </div>
  );
}
